import React, { useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";

import { en, ru, Hindi } from "./data";

import "../../sass/detail.scss"

function Detail() {
  const { nation, page, id } = useParams();
  let pageId = null;
  let imgUrl = null;
  if (nation === "en") {
    switch (page) {
      case "COMPANY":
        pageId = en[0];
        imgUrl = "COMPANY";
        break;
      case "BUSINESS":
        pageId = en[1];
        imgUrl = "BUSINESS";
        break;
      case "PRODUCTS":
        pageId = en[2];
        imgUrl = "PRODUCTS";
        break;
      case "R&D CENTER":
        pageId = en[3];
        imgUrl = "R&D CENTER";
        break;
      case "RECRUIT":
        pageId = en[4];
        imgUrl = "RECRUIT";
        break;
      default:
        break;
    }
  }
  if (nation === "ru") {
    switch (page) {
      case "Компания":
        pageId = ru[0];
        imgUrl = "COMPANY";
        break;
      case "Бизнес":
        pageId = ru[1];
        imgUrl = "BUSINESS";
        break;
      case "Продукты":
        pageId = ru[2];
        imgUrl = "PRODUCTS";
        break;
      case "НИОКР центр":
        pageId = ru[3];
        imgUrl = "R&D CENTER";
        break;
      case "РЕКРУИТ":
        pageId = ru[4];
        imgUrl = "RECRUIT";
        break;
      default:
        break;
    }
  }
  if (nation === "Hindi") {
    switch (page) {
      case "कंपनी":
        pageId = Hindi[0];
        imgUrl = "COMPANY";
        break;
      case "व्यवसाय":
        pageId = Hindi[1];
        imgUrl = "BUSINESS";
        break;
      case "उत्पाद":
        pageId = Hindi[2];
        imgUrl = "PRODUCTS";
        break;
      case "अनुसंधान केंद्र":
        pageId = Hindi[3];
        imgUrl = "R&D CENTER";
        break;
      case "रिक्रयूइट":
        pageId = Hindi[4];
        imgUrl = "RECRUIT";
        break;
      default:
        break;
    }
  }
  const contentTop = useRef(null);
  useEffect(() => {
    contentTop.current.scrollTop = 0;
  }, [page, id])
  return (
    <div className="detail">
      <img src="/image/배경.jpg" alt="" />
      <div className="wrap">
        <div className="container">
          <nav className="side">
            <ul>
              {
                nation == "en"
                  ? en.map((a, i) => {
                    return (
                      <li className={page == a.page ? "on" : ""}><Link className={nation == "ru" ? "ru" : ""} to={`/detail/en/${a.page}/1`}>{a.page}</Link></li>
                    )
                  })
                  : nation == "ru"
                    ? ru.map((a, i) => {
                      return (
                        <li className={page == a.page ? "on" : ""}><Link className={nation == "ru" ? "ru" : ""} to={`/detail/ru/${a.page}/1`}>{a.page}</Link></li>
                      )
                    })
                    : nation == "Hindi"
                      ? Hindi.map((a, i) => {
                        return (
                          <li className={page == a.page ? "on" : ""}><Link className={nation == "Hindi" ? "Hindi" : ""} to={`/detail/Hindi/${a.page}/1`}>{a.page}</Link></li>
                        )
                      })
                      : null
              }
            </ul>
          </nav>
          <div className="content" ref={contentTop}>
            <ul>
              {
                pageId.url.map((a, i) => {
                  return (
                    <li className={id == i + 1 ? "on" : ""}><Link className={nation == "ru" ? "ru" : ""} to={`/detail/${nation}/${page}/${i + 1}`}>{a}</Link></li>
                  )
                })
              }
            </ul>
            <img src={`/image/${nation}/${imgUrl}/${id}.jpg`} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Detail;